
    <!--
 * 横版-首页
 * @LastEditTime: Mon Feb 17 2025 18:24:03 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_7NTW17"  :class="[`normal home-page`,`u_c_7NTW17`]" ><a id="u_c_PZHC67" href="javascript:;" :class="[`normal btn-light info-btn`,`u_c_PZHC67`]" @click="u_c_PZHC67_event_8QY427($event)">{{`${ langData.infoBtn }`}}</a><div id="u_c_79Z717"  :class="[`normal`,`u_c_79Z717`]" ></div><div id="u_c_1W8I18"  v-html="compData.title" :class="[`normal`,`u_c_1W8I18`]" ></div><div id="u_c_EM2A17"  :class="[`normal`,`u_c_EM2A17`]" ><div id="u_c_B4QL30"  v-html="compData.eventTime" :class="[`normal`,`u_c_B4QL30`]" ></div></div><div id="u_c_QC8F28"  :class="[`normal`,`u_c_QC8F28`]" ><div id="u_c_W8CG19"  v-show="!pageData.isLogin" :class="[`normal login-box`,`u_c_W8CG19`]" ><div id="u_c_7FNR44"  :class="[`normal txt`,`u_c_7FNR44`]" >{{`${ langData.pleaseLogin }`}}</div><a id="u_c_N0WW69" href="javascript:;" :class="[`normal txt btn`,`u_c_N0WW69`]" @click="u_c_N0WW69_event_Q72S64($event)">{{`[${ langData.login }]`}}</a></div><div id="u_c_EGB531"  v-show="pageData.isLogin" :class="[`normal login-box`,`u_c_EGB531`]" ><div id="u_c_63WY32"  v-show="pageData.isBind" :class="[`normal txt btn user-server-role`,`u_c_63WY32`]" >{{`${ pageData.serverName }-${ pageData.roleName }`}}</div><div id="u_c_I8HJ34"  :class="[`normal`,`u_c_I8HJ34`]" ><a id="u_c_DBFO35" href="javascript:;" v-show="!pageData.isBind" :class="[`normal txt btn  bind-btn`,`u_c_DBFO35`]" @click="u_c_DBFO35_event_Z75334($event)">{{`[${ langData.bindTitle }]`}}</a><a id="u_c_6OOA37" href="javascript:;" v-show="pageData.isBind && pageData.canReBind" :class="[`normal txt btn  unbind-btn`,`u_c_6OOA37`]" @click="u_c_6OOA37_event_Z75334($event)">{{`[${ langData.changRole }]`}}</a><a id="u_c_J76039" href="javascript:;" :class="[`normal txt btn  bag-btn`,`u_c_J76039`]" @click="u_c_J76039_event_4DJR33($event)">{{`[${ langData.myPackage }]`}}</a><a id="u_c_CP2T41" href="javascript:;" :class="[`normal txt btn logout-btn`,`u_c_CP2T41`]" @click="u_c_CP2T41_event_Q72S64($event)">{{`[${ langData.logout }]`}}</a></div></div></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"eventTime":`活动时间：2023年2月28日 ～2023年3月3日23:59`,"title":`2周年庆典`},"en-US":{"eventTime":`Event Duration: 2025/2/13 23:00:00-2/28 23:59:59 (UTC-5)`,"title":`Valentine's Day Bash`},"ru-RU":{"eventTime":`Event Duration: 2025/2/13 23:00:00-2/28 23:59:59 (UTC-5)`,"title":`Вечеринка в День Св. Валентина`},"pt-PT":{"eventTime":`Event Duration: 2025/2/13 23:00:00-2/28 23:59:59 (UTC-5)`,"title":`Festa do Dia dos Namorados`}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '首页';

    // 自定义setup - 开始
    const checkIsBind = inject("checkIsBind", () => {})
const checkIsLogin = inject("checkIsLogin", () => {})
const listData = inject("listData", {})
const showTips = inject("showTips", (txt, code) => {})

const curPlatform =pagePlatform;

const canClickChange = ref(true);

;
      // 活动规则的click事件
      const u_c_PZHC67_event_8QY427= async (e)=>{
        try {pageData.infoPopupState = true;} catch (error) {console.log(error)}
      };
      // 登入按钮的click事件
      const u_c_N0WW69_event_Q72S64= async (e)=>{
        try {checkIsLogin()} catch (error) {console.log(error)}
      };
      // 绑定按钮的click事件
      const u_c_DBFO35_event_Z75334= async (e)=>{
        try {if (!checkIsLogin()) return
pageData.bindPopupState = true;} catch (error) {console.log(error)}
      };
      // 解绑按钮的click事件
      const u_c_6OOA37_event_Z75334= async (e)=>{
        try {if (!canClickChange.value) return;

canClickChange.value = false;

let res = await request.getJSON(utils.getActivityApi(pagePlatform, pageData.pageId, 'resetUserBind'))
canClickChange.value = true;

if (res.result != 1) {
  showTips(getLangTxt(res.code, getLangTxt("common")), res.code)
  return;
}

pageData.isBind = false;
pageData.roleName = "";
pageData.serverName = "";} catch (error) {console.log(error)}
      };
      // 背包按钮的click事件
      const u_c_J76039_event_4DJR33= async (e)=>{
        try {pageData.bagPopupState = true} catch (error) {console.log(error)}
      };
      // 登出按钮的click事件
      const u_c_CP2T41_event_Q72S64= async (e)=>{
        try {let res = await request.getJSON(utils.getLogoutApi(pagePlatform))
if (res.result == 1) {
  window.location.reload()
}} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_7NTW17.normal{
position:relative;
width:100.00vw;
height:43.07vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434116001-89.jpeg);
overflow:hidden;
margin:auto;
font-size:0;

}
}.default{
.u_c_PZHC67.normal{
position:absolute;
width:10.42vw;
height:3.13vw;
top:1.93vw;
right:87.19vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434115961-55.png);
display:flex;
align-items:center;
font-size:1.15vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
text-align:center;

}
}.default{
.u_c_79Z717.normal{
position:absolute;
width:7.08vw;
height:6.41vw;
top:0.42vw;
right:11.98vw;
background:no-repeat center;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16715369121381.png);
background-size:contain;

}
}.default{
.u_c_1W8I18.normal{
position:absolute;
width:71.35vw;
height:6.04vw;
background:no-repeat center;
background-size:contain;
top:27.29vw;
left:28.44vw;
font-size:4.06vw;
color:#fdd76d;
text-align:bold;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.default{
.u_c_EM2A17.normal{
position:relative;
width:36.09vw;
height:1.93vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1724121831879-26.png);
margin:auto;
margin-top:34.48vw;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:1.15vw;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.default{
.u_c_B4QL30.normal{
position:relative;

}
}.default{
.u_c_QC8F28.normal{
position:relative;
margin:auto;
margin-top:1.46vw;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_QC8F28.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_QC8F28.normal .txt{
font-size:1.15vw;
color:#ffffff;

}

.u_c_QC8F28.normal .btn{
margin:auto 0.52vw;

}
}.default{
.u_c_W8CG19.normal{
position:relative;

}
}.default{
.u_c_7FNR44.normal{
position:relative;

}
}.default{
.u_c_N0WW69.normal{
position:relative;

}
}.default{
.u_c_EGB531.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.default{
.u_c_63WY32.normal{
position:relative;
white-space:nowrap;

}
}.default{
.u_c_I8HJ34.normal{
position:relative;
white-space:nowrap;

}
}.default{
.u_c_DBFO35.normal{
position:relative;

}
}.default{
.u_c_6OOA37.normal{
position:relative;

}
}.default{
.u_c_J76039.normal{
position:relative;

}
}.default{
.u_c_CP2T41.normal{
position:relative;

}
}.en-US{
.u_c_7NTW17.normal{
position:relative;
width:100.00vw;
height:43.07vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434116001-89.jpeg);
overflow:hidden;
margin:auto;
font-size:0;

}
}.en-US{
.u_c_PZHC67.normal{
position:absolute;
width:10.42vw;
height:3.13vw;
top:1.93vw;
right:87.19vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434115961-55.png);
display:flex;
align-items:center;
font-size:1.15vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
text-align:center;

}
}.en-US{
.u_c_79Z717.normal{
position:absolute;
width:7.08vw;
height:6.41vw;
top:0.42vw;
right:11.98vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726743072191-45.png);
background-size:contain;

}
}.en-US{
.u_c_1W8I18.normal{
position:absolute;
width:71.35vw;
height:6.04vw;
background:no-repeat center;
background-size:contain;
top:27.29vw;
left:28.44vw;
font-size:4.06vw;
color:#fdd76d;
text-align:bold;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.en-US{
.u_c_EM2A17.normal{
position:relative;
width:36.09vw;
height:1.93vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1724121831879-26.png);
margin:auto;
margin-top:34.48vw;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:1.15vw;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.en-US{
.u_c_B4QL30.normal{
position:relative;

}
}.en-US{
.u_c_QC8F28.normal{
position:relative;
margin:auto;
margin-top:1.46vw;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_QC8F28.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_QC8F28.normal .txt{
font-size:1.15vw;
color:#ffffff;

}

.u_c_QC8F28.normal .btn{
margin:auto 0.52vw;

}
}.en-US{
.u_c_W8CG19.normal{
position:relative;

}
}.en-US{
.u_c_7FNR44.normal{
position:relative;

}
}.en-US{
.u_c_N0WW69.normal{
position:relative;

}
}.en-US{
.u_c_EGB531.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.en-US{
.u_c_63WY32.normal{
position:relative;
white-space:nowrap;

}
}.en-US{
.u_c_I8HJ34.normal{
position:relative;
white-space:nowrap;

}
}.en-US{
.u_c_DBFO35.normal{
position:relative;

}
}.en-US{
.u_c_6OOA37.normal{
position:relative;

}
}.en-US{
.u_c_J76039.normal{
position:relative;

}
}.en-US{
.u_c_CP2T41.normal{
position:relative;

}
}.ru-RU{
.u_c_7NTW17.normal{
position:relative;
width:100.00vw;
height:43.07vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434116001-89.jpeg);
overflow:hidden;
margin:auto;
font-size:0;

}
}.ru-RU{
.u_c_PZHC67.normal{
position:absolute;
width:10.42vw;
height:3.13vw;
top:1.93vw;
right:87.19vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434115961-55.png);
display:flex;
align-items:center;
font-size:1.15vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
text-align:center;

}
}.ru-RU{
.u_c_79Z717.normal{
position:absolute;
width:7.08vw;
height:6.41vw;
top:0.42vw;
right:11.98vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726743072191-45.png);
background-size:contain;

}
}.ru-RU{
.u_c_1W8I18.normal{
position:absolute;
width:71.35vw;
height:6.04vw;
background:no-repeat center;
background-size:contain;
top:27.29vw;
left:28.44vw;
font-size:4.06vw;
color:#fdd76d;
text-align:bold;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.ru-RU{
.u_c_EM2A17.normal{
position:relative;
width:36.09vw;
height:1.93vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1724121831879-26.png);
margin:auto;
margin-top:34.48vw;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:1.15vw;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.ru-RU{
.u_c_B4QL30.normal{
position:relative;

}
}.ru-RU{
.u_c_QC8F28.normal{
position:relative;
margin:auto;
margin-top:1.46vw;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_QC8F28.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_QC8F28.normal .txt{
font-size:1.15vw;
color:#ffffff;

}

.u_c_QC8F28.normal .btn{
margin:auto 0.52vw;

}
}.ru-RU{
.u_c_W8CG19.normal{
position:relative;

}
}.ru-RU{
.u_c_7FNR44.normal{
position:relative;

}
}.ru-RU{
.u_c_N0WW69.normal{
position:relative;

}
}.ru-RU{
.u_c_EGB531.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.ru-RU{
.u_c_63WY32.normal{
position:relative;
white-space:nowrap;

}
}.ru-RU{
.u_c_I8HJ34.normal{
position:relative;
white-space:nowrap;

}
}.ru-RU{
.u_c_DBFO35.normal{
position:relative;

}
}.ru-RU{
.u_c_6OOA37.normal{
position:relative;

}
}.ru-RU{
.u_c_J76039.normal{
position:relative;

}
}.ru-RU{
.u_c_CP2T41.normal{
position:relative;

}
}.pt-PT{
.u_c_7NTW17.normal{
position:relative;
width:100.00vw;
height:43.07vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434116001-89.jpeg);
overflow:hidden;
margin:auto;
font-size:0;

}
}.pt-PT{
.u_c_PZHC67.normal{
position:absolute;
width:10.42vw;
height:3.13vw;
top:1.93vw;
right:87.19vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/02/1739434115961-55.png);
display:flex;
align-items:center;
font-size:1.15vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
text-align:center;

}
}.pt-PT{
.u_c_79Z717.normal{
position:absolute;
width:7.08vw;
height:6.41vw;
top:0.42vw;
right:11.98vw;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726743072191-45.png);
background-size:contain;

}
}.pt-PT{
.u_c_1W8I18.normal{
position:absolute;
width:71.35vw;
height:6.04vw;
background:no-repeat center;
background-size:contain;
top:27.29vw;
left:28.44vw;
font-size:4.06vw;
color:#fdd76d;
text-align:bold;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.pt-PT{
.u_c_EM2A17.normal{
position:relative;
width:36.09vw;
height:1.93vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/08/1724121831879-26.png);
margin:auto;
margin-top:34.48vw;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:1.15vw;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.pt-PT{
.u_c_B4QL30.normal{
position:relative;

}
}.pt-PT{
.u_c_QC8F28.normal{
position:relative;
margin:auto;
margin-top:1.46vw;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_QC8F28.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_QC8F28.normal .txt{
font-size:1.15vw;
color:#ffffff;

}

.u_c_QC8F28.normal .btn{
margin:auto 0.52vw;

}
}.pt-PT{
.u_c_W8CG19.normal{
position:relative;

}
}.pt-PT{
.u_c_7FNR44.normal{
position:relative;

}
}.pt-PT{
.u_c_N0WW69.normal{
position:relative;

}
}.pt-PT{
.u_c_EGB531.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.pt-PT{
.u_c_63WY32.normal{
position:relative;
white-space:nowrap;

}
}.pt-PT{
.u_c_I8HJ34.normal{
position:relative;
white-space:nowrap;

}
}.pt-PT{
.u_c_DBFO35.normal{
position:relative;

}
}.pt-PT{
.u_c_6OOA37.normal{
position:relative;

}
}.pt-PT{
.u_c_J76039.normal{
position:relative;

}
}.pt-PT{
.u_c_CP2T41.normal{
position:relative;

}
}
</style>
